document.addEventListener('DOMContentLoaded', () => {
  // --- No changes needed in this section ---
  const flavorImageMap = { 'Banana Milkshake': 'banana milkshake.jpg', 'Carrot Cake': 'carrot cake.jpg', 'Cereal Milk': 'cereal milk.jpg', 'Chocolate Milkshake': 'chocolate milkshake.jpg', 'Cinnamon Bun': 'cinnamon bun.jpg', "Cookies 'N' Cream": 'cookies and cream.jpg', 'Custard': 'custard.jpg', 'Lemon Cheesecake': 'lemon cheesecake.jpg', 'Salted Caramel': 'salted caramel.jpg', 'Strawberry Milkshake': 'strawberry milkshake.jpg', 'Toffee Popcorn': 'toffee popcorn.jpg', 'Vanilla Ice Cream': 'vanilla ice cream.jpg', 'White Chocolate & Raspberry': 'white chocolate and raspberry.jpg', 'Choco Bueno': 'choco bueno.jpeg', 'White Choco Bueno': 'white choco bueno.jpeg' };
  const findFlavorImage = (variantName) => { const variantLower = variantName.toLowerCase(); for (const [flavor, imageFile] of Object.entries(flavorImageMap)) { if (variantLower.includes(flavor.toLowerCase())) { return imageFile } } return null };
  const variantRadios = document.querySelector(`variant-radios#variant-radios-${document.querySelector('variant-radios').dataset.section}`);
  if (!variantRadios) { return }
  const flavourFieldset = variantRadios.querySelector('.flavour-dropdown');
  if (!flavourFieldset) { return }
  const sizeFieldset = variantRadios.querySelector('fieldset:not(.flavour-dropdown)');
  const radios = flavourFieldset.querySelectorAll('input[type="radio"]');
  if (radios.length === 0) { return }
  const variantData = JSON.parse(variantRadios.querySelector(`#variant-data-${variantRadios.dataset.section}`).textContent);
  const select = document.createElement('select');
  select.classList.add('flavour-select');
  radios.forEach(radio => {
    const flavorValue = radio.value;
    const isAvailable = variantData.some(v => v.option1 === flavorValue && v.available);
    const option = document.createElement('option');
    option.value = flavorValue;
    option.text = isAvailable ? flavorValue : `${flavorValue}`;
    const imageFile = findFlavorImage(flavorValue);
    option.dataset.image = imageFile ? `${window.ShopifyAssetBaseUrl}${imageFile}` : radio.dataset.image || '';
    option.selected = radio.checked;
    select.appendChild(option);
  });
  flavourFieldset.appendChild(select);
  const choices = new Choices(select, {
    searchEnabled: false,
    itemSelectText: '',
    classNames: { containerOuter: 'flavour-choices' },
    callbackOnCreateTemplates: function (template) {
      return {
        item: ({ classNames }, data) => {
          const imageFile = findFlavorImage(data.value);
          const imageUrl = imageFile ? `${window.ShopifyAssetBaseUrl}${imageFile}` : data.element.dataset.image || '';
          return template(`<div class="${classNames.item} ${data.highlighted ? classNames.highlightedState : ''}" data-item data-id="${data.id}" data-value="${data.value}">${imageUrl ? `<img src="${imageUrl}" alt="${data.value}" class="flavour-image">` : ''}<span>${data.label}</span></div>`)
        },
        choice: ({ classNames }, data) => {
          const imageFile = findFlavorImage(data.value);
          const imageUrl = imageFile ? `${window.ShopifyAssetBaseUrl}${imageFile}` : data.element.dataset.image || '';
          return template(`<div class="${classNames.item} ${classNames.itemChoice} ${data.disabled ? classNames.itemDisabled : ''}" data-choice data-id="${data.id}" data-value="${data.value}">${imageUrl ? `<img src="${imageUrl}" alt="${data.value}" class="flavour-image">` : ''}<span>${data.label}</span></div>`)
        },
      }
    }
  });
  radios.forEach(radio => {
    radio.style.display = 'none';
    radio.nextElementSibling.style.display = 'none';
  });
  // --- End of unchanged section ---

  // This function updates the flavor labels based on the selected size.
  const updateFlavorAvailability = () => {
    const selectedSizeRadio = sizeFieldset ? sizeFieldset.querySelector('input[type="radio"]:checked') : null;
    if (!selectedSizeRadio) return;
    const selectedSize = selectedSizeRadio.value;
    const availableFlavorsForSize = new Set(
      variantData
      .filter(variant => variant.option2 === selectedSize && variant.available)
      .map(variant => variant.option1)
    );
    const allFlavorChoices = choices.getStore().getChoices();
    const newChoices = allFlavorChoices.map(choice => {
      const isAvailable = availableFlavorsForSize.has(choice.value);
      return {
        value: choice.value,
        label: isAvailable ? choice.value : `${choice.value}`,
        disabled: false,
        customProperties: choice.customProperties
      };
    });
    const currentValue = choices.getValue(true);
    choices.setChoices(newChoices, 'value', 'label', true);
    choices.setValue([currentValue]);
  };

  // This function updates the size pills based on the selected flavor.
  const updateSizeAvailability = () => {
    console.log("SIZES UPDATED")
    const selectedFlavor = choices.getValue(true);
    if (!selectedFlavor || !sizeFieldset) {
      return;
    }
    const sizeRadios = sizeFieldset.querySelectorAll('input[type="radio"]');
    sizeRadios.forEach(sizeRadio => {
      const sizeValue = sizeRadio.value;
      const isAvailable = variantData.some(variant =>
        variant.option1 === selectedFlavor &&
        variant.option2 === sizeValue &&
        variant.available
      );

      if (isAvailable) {
        sizeRadio.classList.remove('disabled');
      } else {
        sizeRadio.classList.add('disabled');
      }
    });
  };

  // When the flavor dropdown changes...
  select.addEventListener('change', () => {
    const selectedValue = choices.getValue(true);
    const radioToSelect = Array.from(radios).find(r => r.value === selectedValue);
    if (radioToSelect) {
      radioToSelect.checked = true;
      radioToSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateSizeAvailability();
  });

  // When a size radio button changes...
  if (sizeFieldset) {
    const sizeRadios = sizeFieldset.querySelectorAll('input[type="radio"]');
    sizeRadios.forEach(radio => {
      radio.addEventListener('change', updateFlavorAvailability);
    });
  }

  // Run both functions on initial page load to set the correct state.
  // updateFlavorAvailability(); // Commented out, we dont need this now.
  updateSizeAvailability();
});